import { render, staticRenderFns } from "./modal-message.vue?vue&type=template&id=5afa4ecd&scoped=true"
import script from "./modal-message.vue?vue&type=script&lang=js"
export * from "./modal-message.vue?vue&type=script&lang=js"
import style0 from "./modal-message.vue?vue&type=style&index=0&id=5afa4ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa4ecd",
  null
  
)

export default component.exports